import _ from 'lodash';
import moment from 'moment';

export default function (state, action) {
    if (!state) {
        state = {
            fetchTime: null,
            loaded: false,
            listed: [],
        };
    }

    switch (action.type) {
        case 'EVENT_USER_CONNECTIONS':
            state = Object.assign({}, state, {
                fetchTime: moment(action.fetchTime),
                loaded: true,
                listed: action.connections,
            });
            break;
    }

    return state;
}
